<template>
  <div>
    <div class="cards-container" v-if="this.$route.name === 'people'">
      <card-base v-for="person in popularPeople" :key="person.id">
        <div class="card-container">
          <div class="card-image" @click="goTo('people', person.id)">
            <img :src="'https://image.tmdb.org/t/p/original' + person.profile_path" :alt="person.name">
          </div>
          <div class="card-body">
            <div class="card-name" @click="goTo('people', person.id)">
              <h2>{{ person.name }}</h2>
            </div>
            <div v-if="person.known_for.length > 0" class="card-known">
              <div v-for="show in person.known_for" :key="show.id" class="card-known-item">
                <div class="card-known-item-image">
                  <img :src="'https://image.tmdb.org/t/p/original' + show.poster_path" :alt="show.title ? show.title : show.name"  @click="goTo(show.title ? 'movies' : 'series', show.id)">
                </div>
                <div class="card-known-item-title"  @click="goTo(show.title ? 'movies' : 'series', show.id)">
                  <h5>{{ show.title ? show.title : show.name }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </card-base>
    </div>
    <pagination-base v-model="page" :records="500" @paginate="setPage(page)" /> 
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        popularPeople: [],
        page: 1,
      };
    },
    created() {
      fetch(`https://api.themoviedb.org/3/person/popular?api_key=7e87347114ccb7e8746f73f84d249ab2&language=en-US&page=${this.page}`)
        .then(
          (response) => {
            response.json()
              .then(
                (data) => {
                  this.popularPeople = data.results;
                  console.log(data.results);
                }
              )
          }
        )
    },
    methods: {
      goTo(route, id) {
        if (route === 'people') {
          this.$router.push({path:'/people/' + id});
        } else if (route === 'movies') {
          this.$router.push({path:'/movies/' + id});
        } else if (route === 'series') {
          this.$router.push({path:'/series/' + id});
        }
      },
      setPage(page) {
        this.page = page;
        fetch(`https://api.themoviedb.org/3/person/popular?api_key=7e87347114ccb7e8746f73f84d249ab2&language=en-US&page=${this.page}`)
        .then(
          (response) => {
            response.json()
              .then(
                (data) => {
                  this.popularPeople = data.results;
                }
              )
          }
        )
        window.scrollTo(0,0);
      },
    },
  };
</script>

<style scoped>
  .cards-container {
    margin-top: 52px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .card-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .card-image img {
    width: 400px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    cursor: pointer;
  }

  .card-body {
    height: 100%;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .card-name h2 {
    text-align: center;
    text-transform: uppercase;
    border-bottom: 1px solid #0C1E7F;
    cursor: pointer;
    transition: all 400ms ease-in;
  }

  .card-name h2:hover {
    transform: scale(1.1);
    transition: all 400ms ease-in;
  }

  .card-known {
    display: flex;
    justify-content: space-between;
  }

  .card-known-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .card-known-item-image img {
    width: 120px;
    cursor: pointer;
  }

  .card-known-item-title h5 {
    max-width: 120px;
    margin-block-start: 0;
    margin-block-end: 0;
    font-size: 12px;
    cursor: pointer;
  }

  @media (max-width: 499px) {
    .cards-container {
      margin-top: 60px;
    }

    .card-image img {
      width: 300px;
    }

    .card-name h2 {
      font-size: 16px;
    }

    .card-known {
      flex-direction: column;
    }

    .card-known-item {
      flex-direction: row;
    }

    .card-known-item-image img {
      width: 80px;
      cursor: pointer;
    }

    .card-known-item-title h5 {
      margin-left: 8px;
    }
  }
</style>
